import React from "react";

import JustifiedGrid from "core/JustifiedGrid";
import SubmissionsGridItemContent from "./SubmissionsGridItemContent";

const PendingGroupGrid = ({
    // TODO: remove default mock items when endpoint is ready
    itemData
}) => {
    const items = itemData.map((data, index) => (
        <SubmissionsGridItemContent key={index} submissionData={data} />
    ));

    const itemRatios = itemData.map(data => data.ratio);

    return <JustifiedGrid items={items} itemRatios={itemRatios} />;
};

export default PendingGroupGrid;
